if(!"isInteger" in Number){
	// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number/isInteger
	// http://www.2ality.com/2014/05/is-integer.html
	Number.isInteger = function isInteger(value) {
		// Also check type with strict comparison
		return Math.round(value) === value;
	};
}